module.exports = __webpack_public_path__ + "media/images/chevrons-up-5d7c2212a761f8c08afd9c24a4f1fc12.svg";